<template>
  <div v-if="embedCode" class="mb-8 md:mb-12 relative">
    <div class="bg-white absolute z-10 right-0 rounded-tr-3xl rounded-bl-2xl w-[46px] h-[46px] flex items-center justify-center">
      <AtomIconShort></AtomIconShort>
    </div>
    <iframe
      v-if="embedCode.includes('youtube')"
      width="560"
      height="315"
      :src="embedCode.replace('\/shorts', '/embed')"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    ></iframe>
    <div v-else class="mb-8 md:mb-12" v-html="embedCode"></div>
  </div>
  <div v-else class="mb-8 md:mb-12 relative">
    <a :href="url">
      <div class="bg-white absolute z-10 right-0 rounded-tr-3xl rounded-bl-2xl w-[46px] h-[46px] flex items-center justify-center">
        <AtomIconShort></AtomIconShort>
      </div>
      <MoleculePicture v-if="image" class="w-[283px] h-[504px] block opacity-40" :image="image" img-class="rounded-3xl" />
    </a>
  </div>
</template>

<script setup lang="ts">
defineProps({
  embedCode: { type: String, required: false, default: '' },
  image: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  url: { type: String, required: false, default: '' },
})
</script>

<!-- Styling in this way is needed for loaded shorts iframe -->
<style scoped>
iframe {
  border-radius: 1.5em !important;
  width: 315px;
  height: 560px;
}

blockquote {
  margin: 0 !important;
}
</style>
